export type Validation = {
  validator: (value: string | number) => boolean
  message: string
}

export type Input = {
  key: string
  label: string
  prefilledText?: string
  required?: boolean
  textFieldDisabled?: boolean
  type?: string
  validations?: Validation[]
  helpText?: string
}

export const validateInput = (
  input: Input,
  value: string | number
): { result: boolean; message?: string } => {
  if (!input.validations || input.validations.length === 0) {
    return { result: true }
  }
  for (const validation of input.validations) {
    if (!validation.validator(value)) {
      return { result: false, message: validation.message }
    }
  }
  return { result: true }
}
